import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import { translate } from "../trans";
import { isNullOrUndefined } from "util";
import moment from "moment";
/* eslint-disable */
const state = {
  options: null,
  planOptions: null,
  planIdentity: null,
};

const getters = {
  options: (state) => {
    return state.options;
  },
  planOptions: (state) => {
    return state.planOptions;
  },
  planIdentity: (state) => {
    return state.planIdentity;
  },
};

const actions = {
  allowedDates({ state }, val) {
    //console.log("allowed Dates: ", state.planOptions.PlanEffectiveDate, val);
    const n = Date.parse(val);
    const d = new Date(n);
    const n2 = Date.parse(state.planOptions.PlanEffectiveDate);
    const d2 = new Date(n2);
    return d >= d2;
  },
  getContacts({ commit }, { planId, filter, expand }) {
    const settings = SettingsService.settings;
    let url = settings.APIURL + "plans/" + planId + "/contacts";
    if (filter != null && filter != "") {
      url += "?$filter=" + filter;
    }
    if (expand != null && expand != "") {
      if (filter != null && filter != "") url += "&$expand=" + expand;
      else url += "?$expand=" + expand;
    }
    return ApiService.get(url);
  },

  getPlan({ commit }, id) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      id +
      "?$expand=ProvinceOfRegistration($expand=Translations),Current($expand=Translations,Term,Status($expand=Translations),DueDate),Flags($expand=Translations),Client($select=Name,Id),Broker($select=Name,Id),TrustFund($expand=Translations;$select=Name,Id)";
    return ApiService.get(url);
  },
  async getPlanOptions({ state }, planid) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      planid +
      "?$expand=CurrentPlanMemberEligibility,MembersPortal,Current($expand=Term,ActivityStatuses($expand=Translations),Status($expand=Translations),DueDate),Flags,Client($select=Name,Id),Broker($select=Name,Id),TrustFund($select=Name,Id;$expand=BankAccount)";
    let options = (await ApiService.get(url)).data;
    state.planIdentity = options;
    state.planOptions = options.Current;
  },
  getPlanLogo({ commit }, id) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      id +
      "?$select=Id,BrokerId&$expand=Client($select=LogoBase64)";
    return ApiService.get(url);
  },

  async checkHasCoverageCommencementRules({ state }, { planId, employerId }) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planId +
      "/has-coverage-commencement-rules/Employer/" +
      employerId;
    return (await ApiService.get(url)).data;
  },
  async checkHasCoverageCommencementRulesPlan({ state }, { planId, employerId }) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planId +
      "/has-coverage-commencement-rules";
    return (await ApiService.get(url)).data;
  },
  

  async getPlanParameters({ state }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planid +
      "?$expand=CurrentPlanMemberEligibility,MembersPortal,Current($expand=Term,ActivityStatuses($expand=Translations),Status($expand=Translations),DueDate),Flags,Client($select=Name,Id),Broker($select=Name,Id),TrustFund($select=Name,Id)";
    const options = (await ApiService.get(url)).data;
    return options.Current;
  },
  updatePlan({ commit }, plan) {
    const settings = SettingsService.settings;
    return ApiService.put(settings.APIURL + "plans/" + plan.Id, plan);
  },

  getMembers({ commit }, { planid, expandCols }) {
    const settings = SettingsService.settings;
    let uri = settings.APIURL + "plans/" + planid + "/members";
    if (expandCols != null) {
      uri += "?$Expand=";
      uri += expandCols;
    } else {
      throw new Error("WHATTHEFICK!");
    }
    return ApiService.get(uri);
  },

  newMember({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/members",
      options.member,
    );
  },

  updateMemberUntracked({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/members/untracked",
      options.payload,
    );
  },
  getMember({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL + "plans/" + options.plan + "/members/" + options.id;
    if (options.query) url += "?" + options.query;
    return ApiService.get(url);
  },
  resendMemberRegistrationEmail({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/resend-registration-email";
    return ApiService.post(url, options.payload);
  },
  resendMemberConfirmationEmail({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/resend-confirmation-email";
    return ApiService.post(url, options.payload);
  },
  resendMemberConfirmationEmailPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/resend-confirmation-email-pensions-plan";
    return ApiService.post(url, options.payload);
  },
  resendWelcomeKitEmailPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/resend-welcomekit-email-pensions-plan";
    return ApiService.post(url, options.payload);
  },
  sendManyWelcomeKitEmailsPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      `/send-many-welcomekits-pensions-plan/${options.effectiveDate}`;
    return ApiService.post(url, options.payload);
  },

  getMembersManagementColumns({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planId + "/members-management-columns";
    return ApiService.get(url);
  },

  getDemographicsColumns({ commit }, planId) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + planId + "/demographics-columns";
    return ApiService.get(url);
  },
  getMembersBillingWizardColumns({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planId + "/members-billing-wizard-columns";
    return ApiService.get(url);
  },
  /*getBillingImportColumns({ commit }, planId) {
        const settings = SettingsService.settings
        const url = settings.APIURL + "plans/" + planId + "/billing-import-columns"
        return ApiService.get(url)
    },*/
  getCurrentTerm({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planId + "/currentTerm?$expand=Translations";
    return ApiService.get(url);
  },
  getCurrentTermForRevise({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planId +
      "/currentRevisableTerm?$expand=Translations";
    return ApiService.get(url);
  },
  async unlockId({ commit }, options) {
    try {
      const settings = SettingsService.settings;
      const url = settings.APIURL + "plans/" + options.planId + "/unlock";
      console.log("unlock id: ", options, url);
      ApiService.setUnlockHeader(options.lockId);
      await ApiService.get(url);
    } catch (error) {}
    ApiService.removeHeaders();
  },
  async unlockBuilder({ commit }, options) {
    try {
      const settings = SettingsService.settings;
      const url = settings.APIURL + "plans-management/unlock";
      ApiService.setUnlockHeader(options.lockId);
      await ApiService.get(url);
    } catch (error) {}
    ApiService.removeHeaders();
  },
  async unlockPortalProxy({ commit }, options) {
    try {
      const settings = SettingsService.settings;
      const url = settings.APIURL + "portal-proxy/unlock";
      ApiService.setUnlockHeader(options.lockId);
      await ApiService.get(url);
    } catch (error) {}
    ApiService.removeHeaders();
  },
  async unlockNoPlan({ commit }, options) {
    try {
      const settings = SettingsService.settings;
      const url = settings.APIURL + "unlock";
      ApiService.setUnlockHeader(options.lockId);
      console.log("unlock no plan: ", options, url);
      await ApiService.get(url);
    } catch (error) {}
    ApiService.removeHeaders();
  },

  lockWizard({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.plan + "/lock/addMemberWizard";
    return ApiService.get(url);
  },

  lockMassive({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/lock/massMembersAction";
    return ApiService.post(url, options.memberIdentityIds);
  },

  lockAddPayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/lock/addPaymentForStore/" +
      options.id;
    return ApiService.get(url);
  },

  getBillingTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/billingTerms?$expand=Translations&$orderby=EndDate desc";
    return ApiService.get(url);
  },

  getCompletedBillingTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + options.plan + "/BillingTerms";
    return ApiService.get(url);
  },
  getEmployersReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/employersReports/" +
      options.term;
    return ApiService.get(url);
  },
  getStoresReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/storesReports/" +
      options.term;
    return ApiService.get(url);
  },

  newPaymentStore({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/stores/" +
        options.store +
        "/addPayment",
      options.payload,
    );
  },

  getColumnsOptions({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.plan + "/options/" + options.name;
    return ApiService.get(url);
  },

  getEmployersDropDown({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.plan + "/employers-dropdown";
    return ApiService.get(url);
  },
  getDropDownOptionsWithDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/effectiveDate/" +
      dateFormatted +
      "/" +
      options.url;
    //console.log(url);
    return ApiService.get(url);
  },
  getMemberGroupsWithDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/effectiveDate/" +
      dateFormatted +
      "/memberGroups" +
      options.url;
    //console.log(url);
    return ApiService.get(url);
  },
  getUserPlans({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans?$expand=Current($expand=Translations;$select=Name,Description,IsTesting)&$orderby=Current/Name asc";
    return ApiService.get(url);
  },

  newMemberGroup({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/memberGroups",
      options.memberGroup,
    );
  },

  updateMemberGroup({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "plans/" + options.plan + "/memberGroups/" + options.id,
      options.memberGroup,
    );
  },

  newEmployer({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/employers",
      options.payload,
    );
  },

  updateEmployer({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "plans/" + options.plan + "/employers/" + options.id,
      options.payload,
    );
  },

  deleteEmployer({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.delete(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/employers/" +
        options.employer,
    );
  },

  getStoreById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/stores/" +
        options.id +
        "?$expand=Current($select=IdentityId,Name,PhoneNumber,PhoneNumber2,Fax,Email,StatusId,IsAssignable,Number;$expand=Status($expand=Translations;$select=Name,Id),Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code))),Contacts($select=Name,Id,Email,StatusId,IsPrincipal,IsInHouse;$expand=Status($expand=Translations;$select=Name,Id)),Employer($expand=Current($expand=Translations;$select=Name,IdentityId);$select=Id)&$select=Id,PlanIdentityId,UniqueIdentifier,EmployerId",
    );
  },

  newStore({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/stores",
      options.store,
    );
  },

  updateStore({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "plans/" + options.plan + "/stores/" + options.id,
      options.store,
    );
  },

  deleteStore({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/stores/" +
        options.storeIdentityId +
        "/delete",
      options.payload,
    );
  },

  newContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(settings.APIURL + options.baseUrl, options.contact);
  },

  updateContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + options.baseUrl + "/" + options.contact.Id,
      options.contact,
    );
  },

  deleteContact({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + options.baseUrl + "/" + options.contact;
    return ApiService.delete(url);
  },

  getContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL + options.baseUrl + "/" + options.id + options.query,
    );
  },

  getEmployers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/employers" +
      "?$expand=Current($expand=Translations;$select=IdentityId,Name)&$select=Id";
    return ApiService.get(url);
  },

  getEmployersWithReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/employers" +
      "?$expand=Translations($select=LanguageCode,Id,RefId,Name)&$select=Name,IdentityId";
    return ApiService.get(url);
  },
  getReportEmployerStores({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/employers/" +
      options.employerId +
      "/stores" +
      "?$expand=Translations($select=LanguageCode,Id,Name)&$select=Name,IdentityId";
    return ApiService.get(url);
  },
  /*getEmployersWithReports({ commit }, options) {
        const settings = SettingsService.settings
        const url = settings.APIURL + "plans/" + options.planId + "/billingTerms/" + options.termId + "/employers" + "?$expand=Translations,Stores($expand=Translations;$select=Name,Id)&$select=Name,Id,UniqueIdentifier"
        return ApiService.get(url)
    },*/
  getInsuranceCarriers({ commit }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planid +
      "/insuranceCarriers?$expand=PolicyIdentity($expand=Current($select=Number)),InsuranceCarrier($select=Name;$expand=Translations)&$select=Id";
    return ApiService.get(url);
  },

  getInsuranceCarrier({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/insuranceCarriers/" +
        options.id +
        "?$expand=InsuranceCarrier($select=Name,Id;$expand=Translations),Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code)),Contacts($select=Name,Id,Email,StatusId,IsPrincipal,IsInHouse;$expand=Status($select=Name,Id;$expand=Translations($select=LanguageCode,DisplayValue)))&$select=Id,InsuranceCarrierId,PhoneNumber,Fax,Email",
    );
  },

  getInsuranceCarriersWithReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/insuranceCarriers";
    return ApiService.get(url);
  },
  getBrokersWithReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/brokers";
    return ApiService.get(url);
  },

  getTrustFunds({ commit }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planid +
      "/trustFund?$expand=Translations&$select=Name,Id";
    return ApiService.get(url);
  },
  getReportTrustFund({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/trustFund?$expand=Translations&$select=Name,Id";
    return ApiService.get(url);
  },
  getStores({ commit }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planid +
      "/stores?$expand=Current($expand=Translations;$select=Name,IdentityId)&$select=Id";
    return ApiService.get(url);
  },
  getEmployerStores({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/stores?$expand=Current($expand=Translations;$select=Name,IdentityId)&$select=Id&$filter=EmployerId eq " +
      options.employerIdentityId;
    return ApiService.get(url);
  },
  getAssignableEmployerStores({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/stores?$expand=Current($expand=Translations;$select=Name,IdentityId)&$select=Id&$filter=Current/IsAssignable ne false and EmployerId eq " +
      options.employerId;
    return ApiService.get(url);
  },
  getStoresWithFilter({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/stores?$expand=Current($expand=Translations;$select=Name,IdentityId)&$select=Id&" +
      options.filter;
    return ApiService.get(url);
  },

  updateInsuranceCarrier({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/insuranceCarriers/" +
        options.insuranceCarrier.Id +
        "/details",
      options.insuranceCarrier,
    );
  },

  updateInsuranceCarrierPolicy({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/insuranceCarriers/" +
        options.insuranceCarrier.Id +
        "/policy",
      options.insuranceCarrier,
    );
  },

  newFlag({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/options/flag",
      options.flag,
    );
  },

  updateFlag({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/options/flag/" +
        options.flag.Id,
      options.flag,
    );
  },
  deleteFlag({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.delete(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/options/flag/" +
        options.flagId,
    );
  },

  updateCoverage({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "plans/" + options.plan + "/coverage/" + options.id,
      options.coverage,
    );
  },

  renameCoverageAsync({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/coverage/" +
        options.coverageIdentityId +
        "/rename",
      options.payload,
    );
  },

  renameMemberGroupAsync({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/memberGroups/" +
        options.memberGroupIdentityId +
        "/rename",
      options.payload,
    );
  },

  addCoverageClassificationAsync({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/CoverageClassifications",
      options.payload,
    );
  },
  
  getCoverageClassificationsAsync( {commit}, options){
    const settings = SettingsService.settings;
    const response = ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/CoverageClassifications?$count=true&$skip=0&$top=100&$select=Id,Name,Description"
    );
    return response;
  },

  renameCoverageClassificationAsync({ commit }, options) {
      const settings = SettingsService.settings;
      return ApiService.post(
        settings.APIURL +
          "plans/" +
          options.planIdentityId +
          "/CoverageClassifications/" +
          options.coverageClassificationId +
          "/rename",
        options.payload
      );
  },

  updateTax({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "taxes/" + options.id,
      options.payload,
    );
  },

  updatePensionRegulatorLinks({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "pension-regulators/" + options.id + "/links",
      options.payload,
    );
  },
  updatePensionRegulators({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "pension-regulators/" + options.id,
      options.payload,
    );
  },

  updateCoverageConfiguration({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/configuration-parameter-value/" +
        options.id,
      options.parameterValue,
    );
  },

  getCoverageByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/coverageByDate/" +
      dateFormatted;
    return ApiService.get(url);
  },
  async getCoverageIdentities({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/coverageIdentities?$expand=Current($expand=Translations)";
    return (await ApiService.get(url)).data;
  },
  async getCoverageIdentitiesForCards({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/coverageIdentities?$select=Id&$expand=Current($select=Id,Name,Description,IdentityId;$expand=Translations($select=Name,Description,LanguageCode))";
    return (await ApiService.get(url)).data;
  },
  async saveCoverageIdentitiesHasDrugs({ commit }, { plan, coverage }) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + plan + "/coverage/updateHasDrugs";
    return (await ApiService.put(url, coverage)).data;
  },
  async getSettings({ state }) {
    function sortModel(collection) {
      if (collection === null || collection === undefined) {
        // console.log("undefined: ", collection)
        return [];
      }
      const items = collection.sort((a, b) => {
        return translate(a).localeCompare(translate(b));
      });
      //   console.log(items);
      return items;
    }
    const settings = SettingsService.settings;
    const url = settings.APIURL + "settings";
    let options = (await ApiService.get(url)).data;
    state.options = options;
    //console.log(state.options);
    for (let k of Object.keys(state.options.Models)) {
      state.options.Models[k] = sortModel(state.options.Models[k]);
    }
  },

  async getTrustFund({ state }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/trustfund?$select=Id,Email,Fax,Name,PhoneNumber,PolicyIdentityId&$expand=Translations,Address($expand=Province),BankAccount",
    );
  },

  async updateTrustFund({ state }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL + "plans/" + options.planid + "/trustfund",
      options.payload,
    );
  },

  async getFlags({ state }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      planid +
      "?$expand=Flags($expand=Translations)";
    return (await ApiService.get(url)).data.Flags;
  },

  async getFlag({ state }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/options/flag/" +
      options.id;
    return ApiService.get(url);
  },

  getCoverageConfiguration({ state }, url) {
    const settings = SettingsService.settings;
    return ApiService.get(settings.APIURL + url);
  },
  getHistory({ commit }, options) {
    const settings = SettingsService.settings;
    const uri =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/" +
      options.entity +
      "/" +
      options.item.Id +
      "/history?$skip=1&$top=5&$orderby=EffectiveDate desc" +
      options.expand;
    return ApiService.get(uri);
  },
  getByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery = "";
    if (!isNullOrUndefined(options.expand)) {
      expandQuery = "?" + options.expand;
    }
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/" +
        options.entity +
        "/" +
        options.id +
        "/effectiveDate/" +
        dateFormatted +
        expandQuery,
    );
  },
  getMembershipStatusByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery = "";
    if (!isNullOrUndefined(options.expand)) {
      expandQuery = "?" + options.expand;
    }
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/membershipStatus" +
        options.odataQuery,
    );
  },
  getTaxByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery = "";
    if (!isNullOrUndefined(options.expand)) {
      expandQuery = "?" + options.expand;
    }
    return ApiService.get(
      settings.APIURL +
        "taxes/" +
        options.id +
        "/effectiveDate/" +
        dateFormatted +
        expandQuery,
    );
  },
  getPolicyByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery = "";
    if (!isNullOrUndefined(options.expand)) {
      expandQuery = "?" + options.expand;
    }
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/insuranceCarriers/" +
        options.id +
        "/policyByDate/" +
        dateFormatted +
        "?$expand=Status",
    );
  },
  getInsuranceCarriersPoliciesByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery = "";
    if (!isNullOrUndefined(options.expand)) {
      expandQuery = "?" + options.expand;
    }
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/effectiveDate/" +
        dateFormatted +
        "/insuranceCarriers?$expand=InsuranceCarrier($expand=Translations;$select=Name,Id),PolicyIdentity($expand=Current($select=Number,Id,StatusId,EffectiveDate,PlanIdentityId;$expand=Status($expand=Translations;$select=Name,Id))),Coverage($expand=Translations;$select=Name,Id,EffectiveDate,Description;$expand=Translations,Identity($select=Id,PlanIdentityId))&$select=Id,InsuranceCarrierId",
    );
  },
  getCoverageConfigurationByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/effectiveDate/" +
        dateFormatted +
        "/configuration-parameters?$expand=Translations,CoverageIdentity($expand=Current($expand=Translations($select=Name))),Identity($expand=CurrentDefaultValue($select=Value,Id,IdentityId,EffectiveDate))&$select=Id,IdentityId,Description,ParameterType,CoverageIdentityId,Name,UsedInFormulaType,Type,SystemName",
    );
  },
  getFormulasByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "formulas/" +
        options.plan +
        "/effectiveDate/" +
        dateFormatted,
    );
  },
  getMemberGroupsByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/effectiveDate/" +
        dateFormatted +
        "/memberGroups?$expand=Translations($select=LanguageCode,Name,Description,Kind),Identity($select=HasHistory),CoverageIdentities($expand=Current($select=Name;$expand=Translations($select=LanguageCode,Name))),Status($select=Name,Id;$expand=Translations($select=LanguageCode,DisplayValue))&$select=IdentityId,Name,Id,Description,Kind,StatusId,EffectiveDate",
    );
  },
  getPlanDetailsByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/effectiveDate/" +
        dateFormatted +
        "?$expand=Term,Status,DueDate",
    );
  },
  getCoveragePerYear({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/coveragePerYear/" +
        options.year +
        "?$expand=Translations",
    );
  },
  getT4AColumns({ commit }, plan) {
    const settings = SettingsService.settings;
    return ApiService.get(settings.APIURL + "plans/" + plan + "/t4a-columns");
  },
  getT4ACalculationYear({ commit }, plan) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL + "plans/" + plan + "/currentT4AYear?$select=Id,Year",
    );
  },
  calculateT4A({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/year/" +
        options.year +
        "/calculateT4A",
    );
  },

  updateStatus({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/" +
      options.entity +
      "/changeStatus";
    return ApiService.post(url, options.payload);
  },

  renewPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + options.plan + "/renew";
    return ApiService.post(url, options.payload);
  },

  newDemographicsReport({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/demographics",
      options.payload,
    );
  },
  getDemographicsInsuranceCarrierCoverage({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/insuranceCarriers/" +
        options.insuranceCarrier +
        "/demographicsCoverageByDate/" +
        dateFormatted +
        "?$expand=Translations",
    ); //+"?$filter=IsVolumeApplicable eq true")
  },
  getCoverageByEffectiveDate({ commit }, options) {
    console.log(options);
      const settings = SettingsService.settings
      const [date, time] = options.effectiveDate.split("T");
      const [year, month, day] = date.split("-");
      let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
      return ApiService.get(`${settings.APIURL}plans/${options.planIdentityId}/effectiveDate/${dateFormatted}/coverage?${options.query}`)
  },

  getBlobAsync({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.download(settings.APIURL + options.url);
  },
  getBlobAsyncPost({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.downloadPost(
      settings.APIURL + options.url,
      options.filename,
      options.payload,
    );
  },
  postConfirmMatchMembers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/member-import/parse/" +
      options.guid +
      "/plan-renewal-date/" +
      options.planRenewalDate;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchDependants({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/dependant-import/parse/" +
      options.guid;
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchBilling({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/billing-import/parse/" +
      options.guid;
    return ApiService.post(url, options.payload);
  },
  newDependant({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/members/" +
        options.member +
        "/dependants",
      options.payload,
    );
  },
  newDependantAndBeneficiary({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/members/" +
        options.member +
        "/spouse",
      options.payload,
    );
  },

  updateDependant({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/members/" +
        options.member +
        "/dependants/" +
        options.id,
      options.payload,
    );
  },

  async getPlanConfigurationParameters({ commit }, options) {
    const settings = SettingsService.settings;
    let url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/configuration-parameters?$expand=Identity($select=CurrentDefaultValueHasHistory;$expand=CurrentDefaultValue($select=Value,Id,IdentityId,EffectiveDate)),Translations($select=LanguageCode,Description)&$select=IdentityId,Description,ParameterType,Type,SystemName";
    if (options.filter) url += "&$filter=" + options.filter;
    return (await ApiService.get(url)).data;
  },

  async getTaxParameters({ commit }, options) {
    const settings = SettingsService.settings;
    let url = settings.APIURL + "taxes/getTaxParameterFor/" + options.tax;
    return (await ApiService.get(url)).data;
  },

  async getAllTaxParameters({ commit }, options) {
    const settings = SettingsService.settings;
    let url = settings.APIURL + "taxes/getTaxParameters";
    return (await ApiService.get(url)).data;
  },
  getClaimParameters({ commit }, options) {
    const settings = SettingsService.settings;
    let url = settings.APIURL + "builder-parameters/getClaimParameters";
    return ApiService.get(url);
  },

  async getPlanVariables({ commit }, options) {
    const settings = SettingsService.settings;
    return (
      await ApiService.get(
        settings.APIURL + "plans/" + options.planId + "/billable/fields",
      )
    ).data;
  },

  async getPlanVariablesBuilder({ commit }, options) {
    const settings = SettingsService.settings;
    return (
      await ApiService.post(
        settings.APIURL +
          "plans/" +
          options.planIdentityId +
          "/billable/fields",
        options.payload,
      )
    ).data;
  },

  async testFormula({ commit }, options) {
    const settings = SettingsService.settings;
    return (await ApiService.post(settings.APIURL + "parse-formula", options))
      .data;
  },

  createPlan({ commit }, id) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + id + "/plans";
    return ApiService.post(url, {});
  },

  getAllInsuranceCarriers({ commit }, planid) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "insuranceCarriers?$orderby=Name asc";
    return ApiService.get(url);
  },

  getInsuranceCarrierIndex({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "insuranceCarriersIndex/" +
      options.id +
      "?$expand=Translations";
    return ApiService.get(url);
  },

  updateInsuranceCarrierIndex({ commit }, options) {
    // console.log(options);
    const settings = SettingsService.settings;
    const url = settings.APIURL + "InsuranceCarriers/" + options.id;
    return ApiService.put(url, options.payload);
  },
  deleteInsuranceCarrierIndex({ commit }, options) {
    // console.log(options);
    const settings = SettingsService.settings;
    const url = settings.APIURL + "InsuranceCarriers/" + options.id;
    return ApiService.delete(url);
  },

  getMemberFields({ commit }, planid) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planid + "/members-management/fields";
    return ApiService.get(url);
  },

  getPlanById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "builder/plans/" + options.plan;
    return ApiService.get(url);
  },

  getCalculationEntitiesFormulaTypes({ commit }) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "settings/calculationEntitiesFormulaTypes";
    return ApiService.get(url);
  },

  getDemographicsFields({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/demographics/fields";
    return ApiService.post(url, options.payload);
  },
  getBillingImportFields({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/billing-import/fields";
    return ApiService.post(url, options.payload);
  },
  activatePlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/plans/" +
      options.plan +
      "/activate";
    return ApiService.get(url);
  },
  makeDraft({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "draft-plans/" + options.plan + "/make-draft";
    return ApiService.get(url);
  },
  clearData({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/plans/" +
      options.plan +
      "/clear-data";
    return ApiService.get(url);
  },
  testPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/plans/" +
      options.plan +
      "/test";
    return ApiService.get(url);
  },

  getOrganizationById({ commit }, options) {
    console.log("getOrganizationById", options);
    const settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + options.id;
    return ApiService.get(url);
  },
  addInsuranceCarrier({ commit }, payload) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "insuranceCarriers";
    return ApiService.post(url, payload);
  },

  addOrganization({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "brokers";
    return ApiService.post(url, options.payload);
  },

  addCoverage({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + options.plan + "/coverage";
    return ApiService.post(url, options.payload);
  },

  // addCoverageParameter({ commit }, options) {
  //     const settings = SettingsService.settings;
  //     const url = settings.APIURL + "plans/" + options.plan + "/configuration-parameter-value";
  //     return ApiService.post(url, options.payload);
  // },

  getFormulas({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plans/" + options.plan + "/formulas";
    return ApiService.get(url);
  },
  getCoverageForFormulas({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/coverage";
    return ApiService.get(url);
  },
  getBeneficiaries({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "beneficiaries/" +
      options.planIdentityId +
      "/" +
      options.memberIdentityId +
      "/" +
      options.planInsuranceCarrierId;
    return ApiService.get(url);
  },
  saveBeneficiaries({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "beneficiaryStatements/" + options.planIdentityId;
    return ApiService.post(url, options.payload);
  },
  deleteBeneficiaryStatement({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "beneficiaryStatements/" +
      options.planIdentityId +
      "/" +
      options.statementId;
    return ApiService.delete(url);
  },
  changeMemberEmail({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/change-member-email";
    return ApiService.post(url, options.payload);
  },

  changeMemberEmailPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/change-member-email";
    return ApiService.post(url, options.payload);
  },

  createMemberPortalAccount({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/create-member-portal-account";
    return ApiService.post(url, options.payload);
  },

  deleteMemberPortalAccount({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/delete-member-portal-account";
    return ApiService.post(url, options.payload);
  },
  deleteMemberPortalAccountPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/delete-member-portal-account-pensions-plan";
    return ApiService.post(url, options.payload);
  },
  resetMemberPortalPassword({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/reset-member-portal-password";
    return ApiService.post(url, options.payload);
  },
  resetMemberPortalPasswordPensionsPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/reset-member-portal-password-pensions-plan";
    return ApiService.post(url, options.payload);
  },
  memberPortalViewImpersonate({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.MembersAuth +
      "api/impersonate/" +
      options.planIdentityId +
      "/member/" +
      options.memberIdentityId +
      "?adminEmail=" +
      options.adminEmail +
      `&token=` +
      encodeURIComponent(options.token);
    window.open(url, "_blank");
  },
  memberPortalImpersonateToken({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-portal-impersonate/" +
      options.memberIdentityId +
      "/admin/" +
      options.adminEmail;
    return ApiService.get(url);
  },
  addOrUpdateAllowedUserRecord({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/allowed-users";
    return ApiService.post(url, options.payload);
  },
  deleteAllowedUserRecord({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/allowed-users";
    return ApiService.put(url, options.payload);
  },
  addOrUpdateBlockedUserRecord({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/blocked-users";
    return ApiService.post(url, options.payload);
  },
  deleteBlockedUserRecord({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/blocked-users";
    return ApiService.put(url, options.payload);
  },
  getMemberInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "?" +
      options.odataQuery;
    return ApiService.get(url);
  },
  archiveMemberNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/archive-note";
    return ApiService.post(url, options.payload);
  },
  deleteMemberNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/delete-note";
    return ApiService.post(url, options.payload);
  },

  saveMemberNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberId +
      "/notes";
    return ApiService.post(url, options.payload);
  },
  terminate({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/terminate";
    return ApiService.post(url, options.payload);
  },
  reinstate({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/reinstate";
    return ApiService.post(url, options.payload);
  },
  changeActivityStatus({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/changeActivityStatus";
    return ApiService.post(url, options.payload);
  },
  changeClass({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/changeClass";
    return ApiService.post(url, options.payload);
  },
  getMemberFlags({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberId +
      "?$expand=Flags";
    return ApiService.get(url);
  },
  saveMemberFlags({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/members/flag";
    return ApiService.post(url, {
      Members: [options.memberId],
      Flags: options.flags,
    });
  },
  getPlanFlags({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "?$expand=Flags";
    return ApiService.get(url);
  },
  updateMemberCoverage({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/coverageInformation";
    return ApiService.put(url, options.payload);
  },
  getMemberByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/member-info/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "?" +
        options.odataQuery,
    );
  },
  getMemberCoverageByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery =
      "?$select=Id&$expand=CurrentMemberBenefitYear($select=StartMonth),CurrentMember($select=HasEligibleDependants),CurrentTerminationMembershipEvent($select=DateEffective,TerminationStatus,IsTerminated),CurrentMembershipStatus($select=Id,Class,EffectiveDate,ActivityStatusId,DefaultCoverageStatusId;$expand=SourceOfInformation($expand=Translations),CustomConfigurationParameterValueIdentities($expand=ConfigurationParameterIdentity($select=Id;$expand=Current($select=CoverageIdentityId)),Current($select=Value,SystemType),History($select=Value,SystemType)),DefaultCoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),MemberGroupIdentity($select=Id;$expand=Current($select=Id,Name,IdentityId;$expand=CoverageIdentities($select=Id;$expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses)),Translations($select=LanguageCode,Name)))),CurrentMemberBenefits($select=IsWaived,CurrentPolicy,Volume,NoOfDependants,CoverageIdentityId,EffectiveDate;$expand=DependantIdentities($select=Id),COB($expand=CoverageStatus($expand=Translations($select=LanguageCode,DisplayValue))),CoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),CoverageIdentity($expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses($expand=Translations($select=LanguageCode,DisplayValue)))))";
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/member-info/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        expandQuery,
    );
  },
  getMemberFamilyStatusByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let expandQuery =
      "?$select=Id&$expand=CurrentMember($select=Id;$expand=MaritalStatus($select=Id,Name,AllowSpouse;$expand=Translations($select=LanguageCode,DisplayValue))),";
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/member-info/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        expandQuery,
    );
  },
  getPersonalInfoByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        options.odataQuery,
    );
  },
  updateMemberPersonalInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId;
    return ApiService.put(url, options.payload);
  },
  getEmploymentInfoByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/employmentInformation" +
        options.odataQuery,
    );
  },
  updateMemberEmploymentInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/employmentInformation";
    return ApiService.put(url, options.payload);
  },
  getContactInfoByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/contactInformation" +
        options.odataQuery,
    );
  },
  getMemberUnionLocalByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/union-local-membership" +
        options.odataQuery,
    );
  },
  updateMemberContactInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/contactInformation";
    return ApiService.put(url, options.payload);
  },
  updateMemberUnionLocal({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/union-local-membership";
    return ApiService.put(url, options.payload);
  },
  getActiveNotesCount({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      options.odataQuery;
    return ApiService.get(url);
  },
  getDirectDepositByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/members/" +
        options.memberIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/bankAccount" +
        options.odataQuery,
    );
  },
  updateMemberDirectDeposit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/bankAccount";
    return ApiService.put(url, options.payload);
  },
  getSpouseCount({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    let query =
      "$count=true&$top=0&$filter=IsRemoved ne true and Relationship/IsSpouse eq true";
    if (options.id !== null && options.id !== undefined) {
      query = `$filter=Id ne ${options.id} and Relationship/IsSpouse eq true&$count=true&$top=0`;
    }
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/effectiveDate/" +
        dateFormatted +
        "/members/" +
        options.memberIdentityId +
        "/dependants?" +
        query,
    );
  },

  getNewCertificate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/certificate/" +
        options.entity,
    );
  },
  releaseCertificate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/certificate/release",
      options.payload,
    );
  },
  bulkUpdateEmploymentInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/employmentInformations/bulk-update";
    return ApiService.post(url, options.payload);
  },
  getPlanMemberFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-files?$expand=Note,FileSegments($select=PhysicalFileId,FileName)&$select=Id,CreatedBy,Timestamp,FileCategory&$filter=MemberIdentityId eq " +
      options.memberIdentityId;
    return ApiService.get(url);
  },
  getMemberFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/member-info/" +
      options.memberId +
      "/files";
    return ApiService.get(url);
  },
  replaceMemberFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/member-info/" +
      options.memberId +
      "/replace-file";
    return ApiService.post(url, options.payload);
  },
  addEnrolmentForm({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "/add-enrolment-form";
    return ApiService.post(url, options.payload);
  },
  addOtherFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "/add-other-file";
    return ApiService.post(url, options.payload);
  },
  addChangeForm({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "/add-change-form";
    return ApiService.post(url, options.payload);
  },
  filterEmails({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `file-sharing-receivers/user-brokers/${
      options.brokerId
    }/member-plans/${
      options.planId
    }?$filter=Email ne null and ( contains(tolower(Email), tolower('${
      options.filter
      // }')) or contains(tolower(Type), tolower('${
      //   options.filter
    }')) or contains(tolower(FirstName), tolower('${
      options.filter
    }')) or contains(tolower(LastName), tolower('${options.filter}')))&$top=${
      options.maxDataRetrieved
    }`;
    return ApiService.get(url);
  },
  deleteMemberFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `/plans/${options.planIdentityId}/delete-member-files`;
    return ApiService.post(url, options.payload);
  },
  getEmployersForImport({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/employers-for-import?$expand=Translations($select=LanguageCode,Name)&$select=Id";
    return ApiService.get(url);
  },
  getBillingImportTerm({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/next-term?$select=Id,StartDate,EndDate,IsCompleted,Name,Year";
    return ApiService.get(url);
  },
  postConfirmMatchEmployer({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/contributions/" +
      options.guid +
      "/term/" +
      options.termId;
    return ApiService.post(url, options.payload);
  },
  bulkUpdateContributionTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/contribution-terms";
    return ApiService.post(url, options.payload);
  },
  getEmployerContributionTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/contribution-terms?$expand=Translations";
    return ApiService.get(url);
  },
  deletePayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/payments/" +
      options.paymentId;
    return ApiService.delete(url);
  },
  newPayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/payments";
    return ApiService.post(url, options.payload);
  },
  getEmployerPaymentTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerId +
      "/terms?$select=Id,Name,StartDate,EndDate,IsCompleted&$expand=Translations($select=LanguageCode,FullName)&$orderby=EndDate desc";
    return ApiService.get(url);
  },
  getHourTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/contribution-terms?$select=Id,Name,Year,StartDate,EndDate,IsCompleted&$expand=Translations($select=LanguageCode,Name)&$orderby=EndDate desc";
    return ApiService.get(url);
  },
  getStorePaymentTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/stores/" +
      options.storeId +
      "/terms?$select=Id,Name,StartDate,EndDate,IsCompleted&$expand=Translations($select=LanguageCode,FullName)&$orderby=EndDate desc";
    return ApiService.get(url);
  },
  // TODO refactor for AdminFeeTerms
  getAdminFeeTerms({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      "7540fef8-dd61-ec11-abab-e09467d566b8" +
      "/terms?$select=Id,Name,StartDate,EndDate,IsCompleted&$expand=Translations($select=LanguageCode,Name)&$orderby=EndDate desc";
    return ApiService.get(url);
  },
  async getTotalAdminFee({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planId + "/admin-fees/GetPlanTotal";
    const adminFee = (await ApiService.get(url)).data.value;
    return adminFee;
  },
  newPayment2({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/employers/" +
        options.employer +
        "/addPayment",
      options.payload,
    );
  },
  updatePayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/payments/" +
      options.paymentId;
    return ApiService.put(url, options.payload);
  },
  validateBankAccount({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "bank-accounts/validate";
    return ApiService.post(url, options.payload);
  },
  deleteExpense({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/expenses/" +
      options.expenseId;
    return ApiService.delete(url);
  },
  newExpense({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/expenses";
    return ApiService.post(url, options.payload);
  },
  getBillingTerms2({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/billing-terms?$select=Id,StartDate,EndDate,IsCompleted&$expand=Translations($select=LanguageCode,FullName)&$orderby=EndDate desc";
    return ApiService.get(url);
  },
  updateExpense({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/expenses/" +
      options.expenseId;
    return ApiService.put(url, options.payload);
  },
  newAdminFee({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/admin-fees";
    return ApiService.post(url, options.payload);
  },
  updateAdminFee({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/admin-fees/" +
      options.adminFeeId;
    return ApiService.put(url, options.payload);
  },
  deleteAdminFee({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/admin-fees/" +
      options.adminFeeId;
    return ApiService.delete(url);
  },
  getBillingEmployers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/employers?$select=Id&$expand=Translations($select=LanguageCode,Name)";
    return ApiService.get(url);
  },
  getBillingStores({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/stores?$select=Id&$expand=Translations($select=LanguageCode,Name)";
    console.log(url);
    return ApiService.get(url);
  },
  getBillingInsuranceCarriers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/insurance-carriers?$expand=InsuranceCarrier($select=Id,Name;$expand=Translations($select=LanguageCode,Name))&$select=Id";
    return ApiService.get(url);
  },
  getBillingTrustFund({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/trust-funds?$select=Id,Name&$expand=Translations($select=LanguageCode,Name)";
    return ApiService.get(url);
  },
  addPlanFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-files`;
    return ApiService.post(url, options.payload);
  },
  deletePlanFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `/plans/${options.planIdentityId}/delete-plan-files`;
    return ApiService.post(url, options.payload);
  },
  getPlanFileByDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-files/${options.planFileIdentityId}/effective-date/${dateFormatted}?$expand=Identity($select=FileCategory),Translations($expand=FileSegment)&$select=IdentityId`;
    return ApiService.get(url);
  },
  updatePlanFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-files/${options.payload.IdentityId}`;
    return ApiService.put(url, options.payload);
  },
  getCurrentMemberBenefits({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "?$select=Id&$expand=CurrentActiveMemberBenefits($select=Id;$expand=CoverageIdentity($select=Id;$expand=Current($select=Id;$expand=Translations($select=LanguageCode,Name))))";
    return ApiService.get(url);
  },
  getExtendableMemberBenefits({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-info/" +
      options.memberIdentityId +
      "?$select=Id&$expand=CurrentExtendableMemberBenefits($select=Id;$expand=CoverageIdentity($select=Id;$expand=Current($select=Id;$expand=Translations($select=LanguageCode,Name))))";
    return ApiService.get(url);
  },
  // getMemberTermination({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/members/" +
  //     options.memberIdentityId +
  //     "/terminationStatus";
  //   return ApiService.get(url);
  // },
  // getTerms({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/members/" +
  //     options.memberIdentityId +
  //     "/terminationStatus";
  //   return ApiService.get(url);
  // },
  getMemberHours({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/hour-reports/" +
      options.id +
      "?$expand=Term($expand=Translations($select=LanguageCode,Name))&$select=Id,StartDate,EndDate,Amount,CreatedAt,ChangedAt,MemberId,PlanId,EmployerId";
    return ApiService.get(url);
  },
  addMemberHours({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/hour-reports";
    return ApiService.post(url, options.payload);
  },
  // updateMemberHours({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/members/" +
  //     options.memberIdentityId +
  //     "/hour-reports/" +
  //     options.id;
  //   return ApiService.put(url, options.payload);
  // },
  // deleteMemberHours({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/members/" +
  //     options.memberIdentityId +
  //     "/hour-reports/" +
  //     options.id;
  //   return ApiService.delete(url);
  // },
  getSelfPaymentById({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments/" +
      options.id;
    return ApiService.get(url);
  },
  getMemberSelfPayments({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments/" +
      options.id +
      "?$expand=SelfPaymentCondition";
    return ApiService.get(url);
  },
  addMemberSelfPayments({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments";
    return ApiService.post(url, options.payload);
  },
  updateMemberSelfPayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments/" +
      options.id;;
    return ApiService.put(url, options.payload);
  },
  deleteMemberSelfPayments({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments/" +
      options.id;
    return ApiService.delete(url);
  },
  getMemberSelfPaymentsInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments-total";
    return ApiService.get(url);
  },
  deposit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/self-payments/deposit";
    return ApiService.post(url, options.payload);
  },
  addManyMemberSelfPayments({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/self-payments/many";
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchHours({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/pending-hour-report-import/parse/" +
      options.guid;
    return ApiService.post(url, options.payload);
  },
  getPendingHoursColumns({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-hours-columns";
    return ApiService.get(url);
  },
  addManyPendingHourReports({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-hour-report-import/" +
      options.pendingImportId +
      "/many";
    return ApiService.post(url, options.payload);
  },
  bulkUpdatePendingHoursPage({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-hour-report-import/save";
    return ApiService.put(url, options.payload);
  },
  getTotalInvalidRecords({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports/invalid-records";
    return ApiService.get(url);
  },
  validatePendingHoursPage({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-hour-report-import/" +
      options.pendingImportId +
      "/validate";
    return ApiService.post(url, options.payload);
  },
  finalizePendingHours({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-hour-report-import/pending-imports/" +
      options.pendingImportId +
      "/finalize";
    return ApiService.get(url);
  },
  correctCoverageInformation({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/correct-coverage-effective-date";
    return ApiService.post(url, options.payload);
  },
  correctPlanEntryDateAction({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/correct-plan-entry-date";
    return ApiService.post(url, options.payload);
  },
  deletePendingHoursTask({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId;
    return ApiService.delete(url);
  },
  addNewDraft({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "builder/draft-plans/" + options.brokerId + "/new";
    return ApiService.post(url, options.payload);
  },
  saveDraft({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "builder/brokers/" +
      options.brokerId +
      "/draft-plans/" +
      options.planIdentityId;
    return ApiService.post(url, options.payload);
  },
  validateDraft({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "builder/draft-plans/" +
      options.planIdentityId +
      "/validate";
    return ApiService.get(url);
  },
  deleteDraft({ commit }, id) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "draft-plans/" + id;
    return ApiService.delete(url);
  },
  exportPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "builder/draft-plans/" + options.draftId + "/export";
    return ApiService.get(url);
  },
  getPendingHoursMemberInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports?" +
      options.query;
    return ApiService.get(url);
  },
  getPendingHoursNewMember({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports";
    return ApiService.post(url, options.pendingHourReportIds);
  },
  deletePendingHourImportItem({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports/" +
      options.pendingHourReportId;
    return ApiService.delete(url);
  },
  getContributionControlEmployers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/employers-for-import?$select=Id,Name&$expand=Translations($select=LanguageCode,Name),EmployerContributionTerm($select=IsCustom)";
    return ApiService.get(url);
  },
  getHourImportMemberIdentifiers({ commit }, payload) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "pending-hour-report-data-fields";
    return ApiService.post(url, payload);
  },
  getContributionEmployers({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contributions-control/employers?$expand=Translations($select=LanguageCode,Name),Stores($expand=Translations($select=LanguageCode,Name);$select=Id,IsAssignable,Number),EmployerContributionTerm($select=IsCustom),Terms($select=Id,Name,Year)&$select=Id";
    return ApiService.get(url);
  },
  getTotalTermDues({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/terms/" +
      options.termId +
      "/dues";
    return ApiService.get(url);
  },
  massCreateMembersFromHours({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports/mass-create-members";
    return ApiService.post(url, options.payload);
  },
  getLogicalExpressionsFields({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "commencement-expressions-fields/" +
      options.planIdentityId;
    return ApiService.post(url, options.payload);
  },
  getMemberLogicalExpressionsFields({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "eligibility-expressions-fields/" +
      options.planIdentityId;
    return ApiService.post(url, options.payload);
  },
  getPolicyIdentitiesByCoverageIds({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/policy-identities?$select=Id&$expand=Current($select=Id,Number)";
    return ApiService.post(url, options.payload);
  },
  getLastTerm({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers-for-import/" +
      options.employerId +
      "/contribution-terms?$skip=0&$top=1&$orderby=EndDate desc";
    return ApiService.get(url, options.payload);
  },
  getPolicyIdentitiesByMemberIdentityId({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/policy-identities?$select=Id&$expand=Current($select=Id,Number)";
    return ApiService.get(url);
  },
  getPendingReportTotals({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/pending-imports/" +
      options.pendingImportId +
      "/pending-hour-reports/totals";
    return ApiService.get(url);
  },
  newUnionLocal({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.planIdentityId + "/union-locals",
      options.payload,
    );
  },

  updateUnionLocal({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals/" +
        options.payload.Id,
      options.payload,
    );
  },

  deleteUnionLocal({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.delete(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals/" +
        options.id,
    );
  },
  getUnionLocalByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals/" +
        options.identityId +
        "/effective-date/" +
        options.effectiveDate +
        "?$expand=Identity($expand=Union($select=Name,TradeCode)),Translations($select=Name,LanguageCode),Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code))&$select=Id,Name,PhoneNumber,Fax,Number,Email",
    );
  },
  getPlanUnions({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/unions" +
        "?$select=Id,Name,TradeCode",
    );
  },
  getCurrentUnionLocals({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals" +
        "?$expand=Current($select=IdentityId,Name;$expand=Translations($select=Id,Name,LanguageCode))",
    );
  },
  getUnionLocalsByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/effective-date/" +
        options.effectiveDate +
        "/union-locals" +
        "?$expand=Current($select=IdentityId,Name;$expand=Translations($select=Id,Name,LanguageCode))",
    );
  },
  newUnionLocalContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/union-locals-contacts",
      options.contact,
    );
  },

  updateUnionLocalContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.put(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/union-locals-contacts/" +
        options.contact.Id,
      options.contact,
    );
  },

  getUnionLocalContact({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/union-locals-contacts/" +
        options.id +
        "?$expand=Status($expand=Translations),UnionLocal($expand=Current($select=Name,IdentityId))",
    );
  },

  deleteUnionLocalContact({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/union-locals-contacts/" +
      options.contact;
    return ApiService.delete(url);
  },

  updateContactStatus({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + options.baseUrl + "/changeStatus";
    return ApiService.post(url, options.payload);
  },
  getUnionLocalById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals/" +
        options.identityId +
        "?$expand=Translations($select=Name,LanguageCode),Identity($select=Id;$expand=Union($select=Name,TradeCode)),&$select=Name,Number",
    );
  },
  correctUnionLocal({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/union-locals/" +
        options.identityId +
        "/correct-information",
      options.payload,
    );
  },
  getEmployerById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.employerId +
        "?$expand=Current($expand=Translations,Status($expand=Translations;$select=Name,Id),Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code))),Contacts($select=Name,Id,Email,StatusId,IsPrincipal,IsInHouse;$expand=Status($expand=Translations;$select=Name,Id)),Stores($select=Id,PlanIdentityId,UniqueIdentifier,EmployerId;$expand=Contacts($select=Name,Id,Email,StatusId,IsPrincipal,IsInHouse;$expand=Status($expand=Translations;$select=Name,Id)),Current($select=Name,Number,PhoneNumber,PhoneNumber2,Fax,Email,StatusId,IsAssignable;$expand=Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code)),Status($expand=Translations;$select=Name,Id)))",
    );
  },
  getContributionsEmployerById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/contributions-control/employers/" +
        options.employerId +
        "?$expand=EmployerContributionTerm&$select=Id",
    );
  },
  getEmployerForCorrectInformation({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.employerId +
        "?$expand=Current($expand=Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code));$select=Email,Fax,Id,Name,Number,PhoneNumber,PhoneNumber2,StatusId)&$select=Id,PlanIdentityId",
    );
  },
  correctEmployerInformation({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.payload.Id +
        "/correct-information",
      options.payload,
    );
  },
  getStoreForCorrectInformation({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/stores/" +
        options.storeId +
        "?$expand=Current($expand=Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code));$select=Email,Fax,IdentityId,IsAssignable,Name,Number,PhoneNumber,PhoneNumber2,StatusId)&$select=EmployerId,Id,PlanIdentityId",
    );
  },
  correctStoreInformation({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/stores/" +
        options.payload.Id +
        "/correct-information",
      options.payload,
    );
  },
  getEmployerForLogo({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.employerId +
        "?$expand=Current($expand=Translations;$select=Id,Name,LogoBase64)",
    );
  },
  updateEmployerLogo({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.employerId +
        "/logo",
      options.payload,
    );
  },
  getPlanUniqueIdentifiers({ commit }) {
    const settings = SettingsService.settings;
    return ApiService.get(settings.APIURL + "builder/plans/UniqueIdentifiers");
  },
  getPlanUniqueIdentifiersById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL + "builder/plans/UniqueIdentifiers/" + options.draftId,
    );
  },
  getStoreByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/stores/" +
        options.id +
        "/effective-date/" +
        options.effectiveDate +
        "?$select=IdentityId,Name,PhoneNumber,PhoneNumber2,Fax,Email,StatusId,IsAssignable,Number&$expand=Status($expand=Translations;$select=Name,Id),Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code)),Identity($select=Id,PlanIdentityId,UniqueIdentifier,EmployerId)",
    );
  },
  getEmployerByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/employers/" +
        options.id +
        "/effective-date/" +
        options.effectiveDate +
        "?$select=IdentityId,Name,PhoneNumber,PhoneNumber2,Fax,Email,StatusId,Number&$expand=Status($expand=Translations;$select=Name,Id),Translations,Address($select=City,StreetNumber,StreetName,SuiteNumber,ProvinceId,PostalCode;$expand=Province($select=Name,Id,Code)),Identity($select=Id,PlanIdentityId,UniqueIdentifier)",
    );
  },
  archiveEmployerNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/archive-note";
    return ApiService.post(url, options.payload);
  },
  deleteEmployerNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/delete-note";
    return ApiService.post(url, options.payload);
  },

  saveEmployerNote({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/notes";
    return ApiService.post(url, options.payload);
  },
  getEmployerNotes({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/employers/" +
        options.employerIdentityId +
        "?$expand=Notes($orderby=Timestamp desc;$filter=IsActive eq " +
        (options.showActive ? "true" : "false") +
        ")",
    );
  },
  updateStoreStatus({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/stores/" +
      options.storeIdentityId +
      "/changeStatus";
    return ApiService.post(url, options.payload);
  },
  getPlanEmployerFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employer-files?$expand=Note,FileSegments($select=PhysicalFileId,FileName)&$select=Id,Code,EffectiveDate,ExpiryDate,CreatedBy,Timestamp,FileCategory&$filter=EmployerId eq " +
      options.employerIdentityId;
    return ApiService.get(url);
  },
  getEmployerFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/files";
    return ApiService.get(url);
  },
  replaceEmployerFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/employers/" +
      options.employerIdentityId +
      "/replace-file";
    return ApiService.post(url, options.payload);
  },
  // addEnrolmentForm({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/member-info/" +
  //     options.memberIdentityId +
  //     "/add-enrolment-form";
  //   return ApiService.post(url, options.payload);
  // },
  addEmployerFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/add-file";
    return ApiService.post(url, options.payload);
  },
  // addChangeForm({ commit }, options) {
  //   const settings = SettingsService.settings;
  //   const url =
  //     settings.APIURL +
  //     "plans/" +
  //     options.planIdentityId +
  //     "/member-info/" +
  //     options.memberIdentityId +
  //     "/add-change-form";
  //   return ApiService.post(url, options.payload);
  // },
  getEmployerActiveNotesCount({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "?$select=Id&$expand=Notes($top=0;$count=true;$filter=IsActive eq true)";
    return ApiService.get(url);
  },
  deleteEmployerFiles({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `/plans/${options.planIdentityId}/delete-files`;
    return ApiService.post(url, options.payload);
  },
  getPensionCoverage({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.brokerId +
      "/draft-plans/" +
      options.draftId +
      "/default-pension-coverage";
    return ApiService.get(url);
  },
  memberHasSpouse({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/has-spouse";
    return ApiService.get(url);
  },
  checkUnionLocalNumberUnique({ commit }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/union-local-number-unique";
    return ApiService.post(url, options.payload);
  },
  getRenewalDates({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/member-import/renewal-dates";
    return ApiService.get(url);
  },
  getClaimSubmissionById({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "claim-submission/" + options.claimSubmissionId;
    return ApiService.get(url);
  },
  getClaimSubmissionExpenseInfoById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "expense-info/" + options.claimSubmissionId;
    return ApiService.get(url);
  },
  getClaimSubmissionProofInfoById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "proof-info/" + options.claimSubmissionId;
    return ApiService.get(url);
  },
  getClaimHistoryDetailsByClaimAndPlan({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "claim-history-detail/" +
      options.claimNumber +
      "/" +
      options.planNumber;
    return ApiService.get(url);
  },
  getClaimHistorySummaryByClaim({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "claim-history-summary/" + options.claimNumber;
    return ApiService.get(url);
  },
  getClaimsFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "get-file/" + options.path;
    return ApiService.get(url);
  },
  createMassMemberNotes({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/mass-notes";
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchContactInformation({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/contact-info-import/parse/" +
      options.guid;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchUnionLocalMembership({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/union-local-membership-import/parse/" +
      options.guid;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  getMemberCurrentSickPaymentBalance({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/member-info/${options.memberIdentityId}/current-sick-payment-balance`;
    return ApiService.get(url);
  },
  getPlansThatHaveSickBank({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-hour-bank-settings/brokers/${options.brokerId}/plans`;
    return ApiService.get(url);
  },
  getPlanSickBankSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-hour-bank-settings/plans/${options.planIdentityId}`;
    return ApiService.get(url);
  },
  getSickHourBankSettingsByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}sick-hour-bank-settings/plans/${options.planIdentityId}/effective-date/${dateFormatted}`;
    return ApiService.post(url, options.payload);
  },
  getSickHourBankSettingsById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-hour-bank-settings/${options.id}`;
    return ApiService.get(url);
  },
  addSickHourBankSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-hour-bank-settings`;
    return ApiService.post(url, options.payload);
  },
  updateSickHourBankSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-hour-bank-settings/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  getSickDaySubmissionSettingsByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}sick-day-submission-settings/plans/${options.planIdentityId}/effective-date/${dateFormatted}`;
    return ApiService.post(url, options.payload);
  },
  getSickDaySubmissionSettingsById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-submission-settings/${options.id}`;
    return ApiService.get(url);
  },
  addSickDaySubmissionSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-submission-settings`;
    return ApiService.post(url, options.payload);
  },
  updateSickDaySubmissionSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-submission-settings/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  getSickDayAdjudicationSettingsByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}sick-day-adjudication-settings/plans/${options.planIdentityId}/effective-date/${dateFormatted}`;
    return ApiService.post(url, options.payload);
  },
  getSickDayAdjudicationSettingsById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-adjudication-settings/${options.id}`;
    return ApiService.get(url);
  },
  addSickDayAdjudicationSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-adjudication-settings`;
    return ApiService.post(url, options.payload);
  },
  updateSickDayAdjudicationSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}sick-day-adjudication-settings/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  getMemberTermination({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/termination";
    return ApiService.get(url);
  },
  getMemberTerminationByEffectiveDate({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/terminationStatus/" +
      dateFormatted;
    return ApiService.get(url);
  },
  deleteTermination({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/terminationStatus/" +
      dateFormatted;
    return ApiService.delete(url);
  },
  getMemberTerminationAllowedDates({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/terminationStatus/allowed-dates";
    return ApiService.get(url);
  },
  getMembersEmploymentColumns({ commit }, planId) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + planId + "/members-employment-columns";
    return ApiService.get(url);
  },
  postConfirmMatchMembersEmploymentInformation({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employment-info-import/parse/" +
      options.guid +
      "/plan-renewal-date/" +
      options.planRenewalDate +
      "/identification-field/" +
      options.identificationField;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchActivityStatus({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/activity-status-import/parse/" +
      options.guid;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  postConfirmMatchTerminations({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/terminations-import/parse/" +
      options.guid;
    if (options.sourceOfInformation) {
      return ApiService.postConfirmMatch(
        url,
        options.payload,
        options.sourceOfInformation,
      );
    }
    return ApiService.post(url, options.payload);
  },
  getMemberGroups({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.plan + "/memberGroups" + options.url;
    return ApiService.get(url);
  },
  getEmployerContributionSummaries({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/employers/" +
      options.employerIdentityId +
      "/contributions/summaries";
    return ApiService.get(url);
  },
  getPaymentById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/payments/" +
        options.id +
        "?$expand=Term($select=Id,Name;$expand=Translations($select=LanguageCode,Name)),Employer($select=Id;$expand=Translations($select=LanguageCode,Name)),Store($select=Id;$expand=Translations($select=LanguageCode,Name))",
    );
  },
  getExpenseById({ commit }, options) {
    const settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.planIdentityId +
        "/expenses/" +
        options.id +
        "?$expand=Term($select=Id,Name;$expand=Translations($select=LanguageCode,Name)),Employer($select=Id;$expand=Translations($select=LanguageCode,Name)),Store($select=Id;$expand=Translations($select=LanguageCode,Name)),TrustFund($select=Id,Name;$expand=Translations($select=LanguageCode,Name)),InsuranceCarrier($select=Id,Name;$expand=Translations($select=LanguageCode,Name))",
    );
  },
  getBillingPeriodsWithoutInvoices({ commit }, options) {
    //TODO: check the urls
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/billing-periods-without-invoices";
    return ApiService.get(url);
  },
  generateInvoice({ commit }, options) {
    //TODO: check the urls
    const settings = SettingsService.settings;
    const url = settings.APIURL + "invoices";
    return ApiService.post(url, options.payload);
  },
  getInvoiceById({ commit }, options) {
    //TODO: check the urls
    const settings = SettingsService.settings;
    const url = settings.APIURL + "invoices/" + options.id;
    return ApiService.get(url);
  },
  getPlanFeeConfigurationById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plan-fees-configuration/" + options.id;
    return ApiService.get(url);
  },
  updatePlanFeeConfiguration({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plan-fees-configuration";
    return ApiService.post(url, options.payload);
  },
  getCompletedBillingPeriods({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/billing-terms?$select=Id,FullName&$expand=Translations($select=FullName,LanguageCode)&$filter=IsCompleted eq true & StartDate le ${options.now}`;
    return ApiService.get(url);
  },
  getEmployerStatements({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/employers/${options.employerIdentityId}/statements/balance-report`;
    return ApiService.post(url, options.payload);
  },
  deleteMemberDirectDeposit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/bankAccount";
    return ApiService.delete(url);
  },
  savePortalSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL + "plans/" + options.planIdentityId + "/portal-settings";
    return ApiService.post(url, options.payload);
  },
  addBroker({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}brokers-index`;
    return ApiService.post(url, options.payload);
  },
  updateBroker({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}brokers-index/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  getBrokerById({ commit }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}brokers-index/${options.id}/effective-date/${dateFormatted}?$expand=Identity($select=FirstName,LastName),Translations($select=BrokerageName,LanguageCode),Address($select=City,StreetNumber,SuiteNumber,StreetName,PostalCode;$expand=Province($select=Code))`;
    return ApiService.get(url);
  },
  getBrokerOrganizations({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}brokers-index/${options.id}?$select=Id,FirstName,LastName&$expand=Organizations($select=Name,Id)`;
    return ApiService.get(url);
  },
  assignBroker({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}brokers-index/${options.id}/assign`;
    return ApiService.post(url, options.payload);
  },
  getOrganizationBrokers({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}brokers-index/organization/${options.id}?$select=Id,FirstName,LastName`;
    return ApiService.get(url);
  },
  getMemberCurrentEligibilityBankBalance({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/current-eligibility-bank-balance`;
    return ApiService.get(url);
  },
  getMemberEligibilityBankId({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/eligibility-bank-id`;
    return ApiService.get(url);
  },
  getMemberEligibilityBank({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/eligibility-bank-history/${options.eligibilityBankId}?$filter=CalendarYear eq ${options.calendarYear} and CalendarMonth eq ${options.calendarMonth}`;
    return ApiService.get(url);
  },
  getEligibilityBankEvaluations({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/eligibility-bank-evaluations?$filter=CalendarMonth eq ${options.calendarMonth} and CalendarYear eq ${options.calendarYear}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  evaluateEligibilityHourBank({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/evaluate-eligibility-bank/${options.calendarYear}/${options.calendarMonth}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  eligibilityBankCreditHours({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/credit-hours-eligibility-bank`;
    console.log("url:", url);
    return ApiService.post(url, options);
  },
  eligibilityBankCreditHoursMember({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/credit-hours-eligibility-bank`;
    console.log("url:", url);
    return ApiService.post(url, options.payload);
  },
  eligibilityBankTransferOutMember({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/transfer-out/${dateFormatted}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  eligibilityBankReevaluateMember({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/reevaluate-member-eligibility-bank/${options.memberIdentityId}/${options.calendarYear}/${options.calendarMonth}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  eligibilityBankReevaluate({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/reevaluate-eligibility-bank/${options.calendarYear}/${options.calendarMonth}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  getEligibilityBankMembersDroppedOutOfBenefitsReport({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/eligibility-bank-report-members-out-of-benefit/${options.id}`;
    console.log("url:", url);
    return ApiService.get(url);
  },
  eligibilityBankTransferInMember({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${
      options.memberIdentityId
    }/transfer-in/${options.payload.AsEligible === true}`;
    console.log("url:", url);
    return ApiService.post(url, options.payload);
  },
  eligibilityBankRebalanceMember({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${
      options.memberIdentityId
    }/rebalance`;
    console.log("url:", url);
    return ApiService.post(url, options.payload);
  },
  getEligibilityBankCompletedEvaluations({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/eligibility-bank-evaluations?$top=1&$filter=Status eq 'Completed'`;
      console.log("url:", url);
    return ApiService.get(url);
  },
  getContributionPlan({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}contributions/plans/${options.planIdentityId}`;
      console.log("url:", url);
    return ApiService.get(url);
  },
  getPlanSelfPaymentSettings({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/self-payment-settings?${options.query}`;
      console.log("url:", url);
    return ApiService.get(url);
  },
  getPlanCoverage({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/coverage?${options.query}`;
      console.log("url:", url);
    return ApiService.get(url);
  },
  validateMemberEligibilityBankBalance({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/validate-eligibility-bank-balance`;
      console.log("url:", url);
    return ApiService.post(url, options.payload);
  },
  validateUiTableHeaders({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members-management-columns/check-which-exists`;
    return ApiService.post(url, options.payload);
  },
  getEmployersDateRange({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/employers/date-range?${options.query}`;
      console.log("url:", url);
    return ApiService.get(url);
  },
  getMemberGroupsDateRange({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/member-groups/date-range?${options.query}`;
      console.log("url:", url);
    return ApiService.get(url);
  },
};

const mutations = {};

export const plansMembers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
